import { render } from "./App.vue?vue&type=template&id=cfbe5a3a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=cfbe5a3a&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__